import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import SortBuy from "../dropdown/SortBuy";
import Avatar from 'react-avatar';

JobSec1.propTypes = {};

function JobSec1(props) {
  const { data, pageLoading } = props;

  function isWithinLast48Hours(mongoDate) {
    if (!mongoDate) return false;

    const now = new Date();
    const date = new Date(mongoDate);

    const diffInMs = now - date;
    const fortyEightHoursInMs = 48 * 60 * 60 * 1000;

    return diffInMs >= 0 && diffInMs <= fortyEightHoursInMs;
  };


  return (
    <section className="inner-jobs-section">
      <div className="tf-container">
        <h4>
          Sponsorship Opportunities
        </h4>
        <p>List of all latest and up-to-date sponsorship opportunites in England, Northern Ireland, Scotland, and Wales</p>
        <br />
        {pageLoading ? <p>Loading Sponsorship Jobs</p> : <div className="row">
          <Tabs className="col-lg-12 tf-tab">
            <div className="content-tab">
              {data.length === 0 ? <p>There are no sponsorship opportunities matching your search. Please try another keyword or broaden your search</p> : <TabPanel className="inner">
                {data.slice(0, 9).map((idx) => (
                  <div key={idx.id} className="features-job style-3">
                    <div className="inner-box">
                      <div className="company">
                        <div className="logo-company">
                          <Avatar size="40" name={idx.jobTitle} />
                        </div>
                        <div className="box-content">
                          <h4>
                            <Link to={`/jobs/${idx.slug}`}>{idx.industryCategory}</Link>
                          </h4>
                          <h3>
                            <Link to={`/jobs/${idx.slug}`}>{idx.jobTitle}</Link>
                            &nbsp;
                            {isWithinLast48Hours(idx.createdAt) && (
                              <span className="icon-bolt"></span>
                            )}
                          </h3>
                        </div>
                      </div>
                      <ul className="info">
                        <li>
                          <span className="icon-map-pin"></span>
                          {idx.address}
                        </li>
                      </ul>
                      <div className="category">
                        <ul className="job-tag">
                          <li>
                            <Link to={`/jobs/${idx.slug}`}>     {idx.jobType}</Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <Link
                      to={`/jobs/${idx.slug}`}
                      className="jobtex-link-item"
                      tabIndex="0"
                    ></Link>
                  </div>
                ))}

                <ul className="pagination-job padding">
                  {/* <li>
                    <Link to="#">
                      <i className="icon-keyboard_arrow_left"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">1</Link>
                  </li>
                  <li className="current">
                    <Link to="#">2</Link>
                  </li>
                  <li>
                    <Link to="#">3</Link>
                  </li>
                  <li>
                    <Link to="#">
                      <i className="icon-keyboard_arrow_right"></i>
                    </Link>
                  </li> */}
                </ul>
              </TabPanel>}
              {/* <TabPanel className="inner">
                <div className="group-col-3">
                  {data.map((idx) => (
                    <div key={idx.id} className="features-job cl3">
                      <div className="job-archive-header">
                        <div className="inner-box">
                          <div className="logo-company">
                            <img src={idx.img} alt="jobtex" />
                          </div>
                          <div className="box-content">
                            <h4>
                              <Link to="/jobsingle_v1">{idx.cate}</Link>
                            </h4>
                            <h3>
                              <Link to="/jobsingle_v1"> {idx.title} </Link>
                              <span className="icon-bolt"></span>
                            </h3>
                            <ul>
                              <li>
                                <span className="icon-map-pin"></span>
                                {idx.map}
                              </li>
                              <li>
                                <span className="icon-calendar"></span>
                                {idx.time}
                              </li>
                            </ul>
                            <span className="icon-heart"></span>
                          </div>
                        </div>
                      </div>
                      <div className="job-archive-footer">
                        <div className="job-footer-left">
                          <ul className="job-tag">
                            <li>
                              <Link to="#">{idx.jobs1}</Link>
                            </li>
                            <li>
                              <Link to="#">{idx.jobs2}</Link>
                            </li>
                          </ul>
                          <div className="star">
                            <span className="icon-star-full"></span>
                            <span className="icon-star-full"></span>
                            <span className="icon-star-full"></span>
                            <span className="icon-star-full"></span>
                            <span className="icon-star-full"></span>
                          </div>
                        </div>
                        <div className="job-footer-right">
                          <div className="price">
                            <span className="icon-dolar1"></span>
                            <p>
                              {idx.price}
                              <span className="year">/year</span>
                            </p>
                          </div>
                          <p className="days">{idx.apply}</p>
                        </div>
                      </div>
                      <Link
                        to="/jobsingle_v1"
                        className="jobtex-link-item"
                        tabIndex="0"
                      ></Link>
                    </div>
                  ))}
                </div>

                <ul className="pagination-job padding">
                  <li>
                    <Link to="#">
                      <i className="icon-keyboard_arrow_left"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">1</Link>
                  </li>
                  <li className="current">
                    <Link to="#">2</Link>
                  </li>
                  <li>
                    <Link to="#">3</Link>
                  </li>
                  <li>
                    <Link to="#">
                      <i className="icon-keyboard_arrow_right"></i>
                    </Link>
                  </li>
                </ul>
              </TabPanel> */}
            </div>
          </Tabs>
        </div>}
      </div>
    </section>
  );
}

export default JobSec1;
